'use client'
import { cleanDialogStack } from '@patrianna/dialog-manager'
import { CustomPropsProvider } from '@patrianna-ui-features/location-verification'
import { config } from '@patrianna-ui-features/location-verification/src/server'
import { useSearchParams, useRouter } from 'next/navigation'
import { type ReactNode } from 'react'

import CloseButton from 'app/(pages)/location/components/CloseButton'
import Button from 'components/Button'
import ButtonLink from 'components/ButtonLink'
import { LogoutButton } from 'components/LogoutButton'
import ROUTES from 'config/routes.json'
import LogoLink from 'containers/LogoLink'
import { useAppSelector } from 'store/hooks'
import { enabledSweepstake } from 'store/modules/appConfig/actions'
import { isAppInitializedSelector, sweepstakeEnabledSelector } from 'store/modules/appConfig/selectors'
import { getAccountInfo, setAccountMode, setLocationStatus } from 'store/modules/user/actions'
import { getUserLocationStatus, isLoggedInSelector } from 'store/modules/user/selectors'

import classes from './styles.module.scss'

type Props = {
  children: ReactNode
}

const locationVerificationConfig = {
  // @ts-ignore
  useRouter,
  routes: {
    verifyLocation: ROUTES.LOCATION_VERIFICATION,
    locationRestricted: ROUTES.LOCATION_RESTRICTED,
    home: ROUTES.HOME,
  },
  customClassNames: {
    verification: {
      title: classes.title,
      description: classes.description,
      restricted: classes.restricted,
      buttonsContainer: classes.buttonsContainer,
      enableButton: classes.enableButton,
      recheckButton: classes.recheckButton,
    },
    restricted: {
      title: classes.title,
      description: classes.description,
      restricted: classes.restricted,
      recheck: classes.recheck,
      buttonLink: classes.buttonLink,
      gpsDeniedMessage: classes.gpsDeniedMessage,
      gpsDeniedIcon: classes.gpsDeniedIcon,
      gpsDeniedContent: classes.gpsDeniedContent,
      gpsDeniedTitle: classes.gpsDeniedTitle,
      gpsDeniedDescription: classes.gpsDeniedDescription,
    },
  },
  feature: {
    verificationImage: {
      path: '/register/verification.png',
      width: 180,
      height: 150,
    },
    restrictedImage: {
      path: '/register/restricted.png',
      width: 180,
      height: 150,
    },
    gpsDeniedIcon: {
      path: '/register/gps-denied-red.svg',
      width: 24,
      height: 24,
    },
  },
  components: {
    Button,
    ButtonLink,
    CloseButton,
    LogoutButton,
    LogoLink,
  },
  actions: {
    setLocationStatus,
    closeAllDialogs: cleanDialogStack,
    setAccountMode,
    enabledSweepstake,
    getAccountInfo,
  },
  selectors: {
    getUserLocationStatus,
    isLoggedInSelector,
    isAppInitializedSelector,
  },
}

config.setConfig(locationVerificationConfig)

export default function VerifyLocationConfigProvider({ children }: Props) {
  const query = useSearchParams()
  const redirect = query.get('redirect')
  const isLoggedIn = useAppSelector(isLoggedInSelector)
  const isScEnabled = useAppSelector(sweepstakeEnabledSelector)

  const customProps = {
    redirect,
    isLoggedIn,
    isScEnabled,
  }

  return <CustomPropsProvider customProps={customProps}>{children}</CustomPropsProvider>
}
